@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.location.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mifos_mobile.feature.location.generated.resources/"

internal val Res.string.map_marker_desc: StringResource by lazy {
      StringResource("string:map_marker_desc", "map_marker_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 59),
      ))
    }

internal val Res.string.map_marker_heading: StringResource by lazy {
      StringResource("string:map_marker_heading", "map_marker_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70, 38),
      ))
    }

internal val Res.string.mifos_initiative: StringResource by lazy {
      StringResource("string:mifos_initiative", "mifos_initiative", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109, 48),
      ))
    }

internal val Res.string.mifos_location: StringResource by lazy {
      StringResource("string:mifos_location", "mifos_location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 158, 82),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("map_marker_desc", Res.string.map_marker_desc)
  map.put("map_marker_heading", Res.string.map_marker_heading)
  map.put("mifos_initiative", Res.string.mifos_initiative)
  map.put("mifos_location", Res.string.mifos_location)
}
